// https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0
export const hashCode = (inputString: string) => {
    let hash: number = 0;
    for (let i = 0; i < inputString.length; i++) hash = (Math.imul(31, hash) + inputString.charCodeAt(i)) | 0;

    return hash;
};
